var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-dropdown",
        {
          ref: "options_dropdown",
          attrs: { lazy: true, variant: "success" },
          scopedSlots: _vm._u([
            {
              key: "button-content",
              fn: function () {
                return [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "v-b-tooltip",
                          rawName: "v-v-b-tooltip.right",
                          value:
                            "This will plot data from local files. Nothing will be uploaded and these tracks will disappear when the page reloads.",
                          expression:
                            "'This will plot data from local files. Nothing will be uploaded and these tracks will disappear when the page reloads.'",
                          modifiers: { right: true },
                        },
                      ],
                    },
                    [_vm._v("Add tabix-indexed datafile")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _c("div", { staticClass: "px-3", staticStyle: { width: "300px" } }, [
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.createReader.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "b-form-group",
                  { attrs: { label: "Data source" } },
                  [
                    _c("b-form-radio-group", {
                      attrs: {
                        id: "tabix-location",
                        options: [
                          { text: "File", value: "file" },
                          { text: "URL", value: "url" },
                        ],
                        name: "tabix-location",
                      },
                      model: {
                        value: _vm.tabix_mode,
                        callback: function ($$v) {
                          _vm.tabix_mode = $$v
                        },
                        expression: "tabix_mode",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.tabix_mode === "file"
                  ? [
                      _c("input", {
                        ref: "file_picker",
                        staticClass: "form-control",
                        attrs: {
                          required: _vm.tabix_mode === "file",
                          type: "file",
                          multiple: "",
                          accept: "application/gzip,.tbi",
                        },
                        on: { change: _vm.updateDisplayName },
                      }),
                    ]
                  : [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.tabix_gz_url,
                            expression: "tabix_gz_url",
                            modifiers: { trim: true },
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          required: _vm.tabix_mode === "url",
                          type: "url",
                          placeholder: "Specify URL...",
                        },
                        domProps: { value: _vm.tabix_gz_url },
                        on: {
                          blur: [
                            _vm.updateDisplayName,
                            function ($event) {
                              return _vm.$forceUpdate()
                            },
                          ],
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.tabix_gz_url = $event.target.value.trim()
                          },
                        },
                      }),
                    ],
                _c("br"),
                _vm._v(" "),
                _c(
                  "b-form-group",
                  { attrs: { label: "Type" } },
                  [
                    _c(
                      "b-form-radio",
                      {
                        attrs: { name: "data-type", value: "gwas" },
                        model: {
                          value: _vm.data_type,
                          callback: function ($$v) {
                            _vm.data_type = $$v
                          },
                          expression: "data_type",
                        },
                      },
                      [
                        _vm._v("\n            GWAS scatter plot ("),
                        _c("small", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://my.locuszoom.org/about/#prepare-data",
                                target: "_blank",
                              },
                            },
                            [_vm._v("suggested fields")]
                          ),
                        ]),
                        _vm._v(")\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-radio",
                      {
                        attrs: { name: "data-type", value: "bed" },
                        model: {
                          value: _vm.data_type,
                          callback: function ($$v) {
                            _vm.data_type = $$v
                          },
                          expression: "data_type",
                        },
                      },
                      [
                        _vm._v("\n            BED 4+ intervals "),
                        _c("small", [
                          _vm._v("("),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "https://genome.ucsc.edu/FAQ/FAQformat.html#format1",
                                target: "_blank",
                              },
                            },
                            [_vm._v("file format")]
                          ),
                          _vm._v(")"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.allow_ld
                      ? _c(
                          "b-form-radio",
                          {
                            attrs: { name: "data-type", value: "plink_ld" },
                            model: {
                              value: _vm.data_type,
                              callback: function ($$v) {
                                _vm.data_type = $$v
                              },
                              expression: "data_type",
                            },
                          },
                          [
                            _vm._v(
                              "\n            PLINK 1.9 LD (overlay on GWAS; see "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  target: "_blank",
                                  href: "https://statgen.github.io/localzoom#instructions",
                                },
                              },
                              [_vm._v("instructions")]
                            ),
                            _vm._v(")\n          "),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("b-form-group", { attrs: { label: "Track Label" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model.trim",
                        value: _vm.display_name,
                        expression: "display_name",
                        modifiers: { trim: true },
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", required: "" },
                    domProps: { value: _vm.display_name },
                    on: {
                      blur: [
                        _vm.updateDisplayName,
                        function ($event) {
                          return _vm.$forceUpdate()
                        },
                      ],
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.display_name = $event.target.value.trim()
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("input", {
                  staticClass: "btn btn-success",
                  attrs: { type: "submit", value: "Add dataset" },
                }),
              ],
              2
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.show_gwas_modal
        ? _c("gwas-parser-options", {
            attrs: { file_reader: _vm.tabix_reader },
            on: {
              ready: _vm.receiveGwasOptions,
              close: function ($event) {
                _vm.show_gwas_modal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }